import gql from 'graphql-tag';

export const FRAGMENT_TAG = gql`
    fragment tag on Tag {
        id
        parentId
        value
    }
`;
